import { useEffect, useMemo, useState } from 'react';

/**
 * Pagination client réutilisable.
 * @param items    liste complète (déjà filtrée) à paginer
 * @param perPage  éléments par page
 * @param resetKey change de valeur pour revenir à la page 1 (ex: filtre/recherche)
 */
export function usePagination<T>(items: T[], perPage = 10, resetKey?: string | number) {
  const [page, setPage] = useState(0);

  // Revenir à la première page quand le filtre/la recherche change.
  useEffect(() => { setPage(0); }, [resetKey]);

  const pageCount = Math.max(1, Math.ceil(items.length / perPage));
  const safePage = Math.min(page, pageCount - 1);

  const pageItems = useMemo(
    () => items.slice(safePage * perPage, safePage * perPage + perPage),
    [items, safePage, perPage]
  );

  return {
    page: safePage,
    setPage,
    pageCount,
    pageItems,
    perPage,
    total: items.length,
    from: items.length === 0 ? 0 : safePage * perPage + 1,
    to: Math.min((safePage + 1) * perPage, items.length),
  };
}

export default usePagination;
